import gql from "graphql-tag";

export const importPersonExperienceAttendance = gql`
    mutation ImportPersonExperienceAttendance(
        $data: [ImportPersonExperienceAttendanceInput]) {
        importPersonExperienceAttendance(data: $data)
    }
`;
